import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";

/*
|-------------------------------------------------------------------------------
| (Stable) Sort
|-------------------------------------------------------------------------------
|
| The main case for "stable" sort algorithms are to retain order from
| categorical sorting of collections.
|
| We need this when grouping (matching) routes together.
|
*/
export function defaultCompare(a, b) {
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
}
export function sortStable(collection) {
  var compare = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultCompare;

  var stableArr = _mapInstanceProperty(collection).call(collection, function (el, index) {
    return [el, index];
  });

  _sortInstanceProperty(stableArr).call(stableArr, function (a, b) {
    var order = compare(a[0], b[0]);
    if (order !== 0) return order === false ? -1 : order === true ? 1 : order;
    return a[1] - b[1];
  });

  return _mapInstanceProperty(stableArr).call(stableArr, function (i) {
    return i[0];
  });
}
export function byMatchedIndex(a, b) {
  return defaultCompare(a.matchIndex || -1, b.matchIndex || -1);
}